import {Person, Project, StyledBaseProps} from "@betrue/shared/interfaces";
import styled from "styled-components";
import {ProjectDetailsProps, ProjectList, ProjectProductList} from "@betrue/ui";
import * as React from "react";
import {Button, Chip, Divider, Grid, Typography} from "@material-ui/core";
import moment from "moment";

interface ProjectDetailsViewProps extends StyledBaseProps, ProjectDetailsProps {
  currentUser: Person,
  project: Project
}

export const ProjectDetailsView = styled((props: ProjectDetailsViewProps) => {

  return (
    <div className={props.className}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={3}>
        <Grid item xs={12}>
          <Typography gutterBottom color="textSecondary"variant="body1">
            {props.projectNameLabel}
          </Typography>
          <Divider variant="fullWidth"/>

          <Typography gutterBottom variant="h4">
            {props.project.name}
          </Typography>


        </Grid>
        <Grid item xs={12}>
          <Typography gutterBottom color="textSecondary"variant="body1">
            {props.projectDescriptionLabel}
          </Typography>
          <Divider variant="fullWidth"/>
          <Typography color="textSecondary" variant="h5">
            {props.project.description}.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography gutterBottom color="textSecondary"variant="body1">
            {props.projectDeadLineLabel}
          </Typography>
          <Divider variant="fullWidth"/>
          <Typography color="textSecondary" variant="body1">
            {moment(props.project.dueDate).format('YYYY-MM-DD')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography gutterBottom color="textSecondary"variant="body1">
            {props.projectStateLabel}
          </Typography>
          <Divider variant="fullWidth"/>
          <Typography color="textSecondary" variant="body1">
            En attente de validation :-)
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button color="primary"
                  variant={"outlined"}
                  onClick={() => {
                    window.location.href = props.editUrl + `?projectId=${props.project.id}`
                  }}>
            {props.editLabel}
          </Button>
        </Grid>

      </Grid>

    </div>
  )
})`


`
